import { Component } from '@angular/core';
import { ToastController } from '@ionic/angular'
import { Router } from '@angular/router';

import { BasePage } from '../base.page';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'contratacao-page',
    templateUrl: 'contratacao.page.html',
    styleUrls: ['contratacao.page.scss']
})
export class ContratacaoPage extends BasePage {
    constructor(
        private sanitizer: DomSanitizer,
        public router: Router, 
        public toastCtrl: ToastController) {
        super(router)
    }

    corTextoPagina: string
    url = "https://app.phicube.com.br/planos/"
    safeURL: SafeResourceUrl

    ngOnInit() {
        this.getUrlPagina()
    }

    async getUrlPagina() {
        this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }
}
